import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.94967 7.30001C6.14298 7.1067 6.4564 7.1067 6.64971 7.30001L8.99969 9.64999L11.3497 7.30001C11.543 7.1067 11.8564 7.1067 12.0497 7.30001C12.243 7.49332 12.243 7.80674 12.0497 8.00005L9.34971 10.7C9.1564 10.8934 8.84298 10.8934 8.64967 10.7L5.94967 8.00005C5.75636 7.80674 5.75636 7.49332 5.94967 7.30001Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }